<template>
  <div>
    <h5 class="page-sub-title pl-2 pl-md-4 mt-3 mt-md-4">住民票取得代行</h5>
    <table class="table">
      <tr>
        <th>住民票取得代行のご希望</th>
        <td>
          <div class="row">
            <div class="col-md-4 col-lg-3">
              <validation-provider
                name="JYUMINHYO_DAIKO_FLG"
                v-slot="{ errors }"
              >
                <b-form-select
                  ref="JYUMINHYO_DAIKO_FLG"
                  v-model="form.JYUMINHYO_DAIKO_FLG"
                  :state="errors.length ? false : null"
                  :options="yesNoHopeList"
                  trim
                />
                <b-form-invalid-feedback>
                  <span class="border-red">{{ errors[0] }}</span>
                </b-form-invalid-feedback>
              </validation-provider>
            </div>
          </div>
        </td>
      </tr>
    </table>

    <table v-if="form.JYUMINHYO_DAIKO_FLG" class="table">
      <tr>
        <th>生年月日</th>
        <td>
          <div class="row mx-0">
            <validation-provider
              name="JYUMINHYO_DAIKO_YEAR"
              v-slot="{ errors }"
            >
              <b-form-select
                ref="JYUMINHYO_DAIKO_YEAR"
                v-model="form.JYUMINHYO_DAIKO_YEAR"
                :state="errors.length ? false : null"
                :options="yearList"
                trim
                @change="form.JYUMINHYO_DAIKO_DAY = null"
              />
              <b-form-invalid-feedback>
                <span class="border-red">{{ errors[0] }}</span>
              </b-form-invalid-feedback>
            </validation-provider>
            <span class="mt-2 ml-1 mr-3">年</span>

            <validation-provider
              name="JYUMINHYO_DAIKO_MONTH"
              v-slot="{ errors }"
            >
              <b-form-select
                ref="JYUMINHYO_DAIKO_MONTH"
                v-model="form.JYUMINHYO_DAIKO_MONTH"
                :state="errors.length ? false : null"
                :options="monthList"
                trim
                @change="form.JYUMINHYO_DAIKO_DAY = null"
                :disabled="!form.JYUMINHYO_DAIKO_YEAR"
              />
              <b-form-invalid-feedback>
                <span class="border-red">{{ errors[0] }}</span>
              </b-form-invalid-feedback>
            </validation-provider>
            <span class="mt-2 ml-1 mr-3">月</span>

            <validation-provider name="JYUMINHYO_DAIKO_DAY" v-slot="{ errors }">
              <b-form-select
                ref="JYUMINHYO_DAIKO_DAY"
                v-model="form.JYUMINHYO_DAIKO_DAY"
                :state="errors.length ? false : null"
                :options="
                  dayList(form.JYUMINHYO_DAIKO_YEAR, form.JYUMINHYO_DAIKO_MONTH)
                "
                trim
                :disabled="
                  !form.JYUMINHYO_DAIKO_YEAR || !form.JYUMINHYO_DAIKO_MONTH
                "
              />
              <b-form-invalid-feedback>
                <span class="border-red">{{ errors[0] }}</span>
              </b-form-invalid-feedback>
            </validation-provider>
            <span class="mt-2 ml-1">日</span>
          </div>
        </td>
      </tr>
      <tr>
        <th>
          住民票と登録地が異なりますか？
          <span class="must">必須</span>
        </th>
        <td>
          <div class="row">
            <div class="col-md-3">
              <validation-provider
                name="JYUMINHYO_FLG"
                v-slot="{ errors }"
                rules="required"
              >
                <b-form-select
                  v-model="form.JYUMINHYO_FLG"
                  ref="JYUMINHYO_FLG"
                  :state="errors.length ? false : null"
                  :options="yesNoFumeiList"
                  trim
                />
                <b-form-invalid-feedback>
                  <span class="border-red">{{ errors[0] }}</span>
                </b-form-invalid-feedback>
              </validation-provider>
            </div>
          </div>
        </td>
      </tr>
      <tr v-if="isDiffrent">
        <th>住民票 郵便番号</th>
        <td>
          <div class="row">
            <div class="col-4 col-md-3">
              <validation-provider
                v-slot="{ errors }"
                rules="numeric|digits:3"
                name="JYUMINHYO_YUBIN1"
              >
                <b-form-input
                  type="tel"
                  ref="JYUMINHYO_YUBIN1"
                  maxlength="3"
                  v-model="form.JYUMINHYO_YUBIN1"
                  :state="errors.length ? false : null"
                  placeholder="160"
                  trim
                />
                <b-form-invalid-feedback>
                  <span class="border-red">{{ errors[0] }}</span>
                </b-form-invalid-feedback>
              </validation-provider>
            </div>
            <span class="py-2">-</span>
            <div class="col-4 col-md-3">
              <validation-provider
                v-slot="{ errors }"
                rules="numeric|digits:4"
                name="JYUMINHYO_YUBIN2"
              >
                <b-form-input
                  type="tel"
                  ref="JYUMINHYO_YUBIN2"
                  maxlength="4"
                  v-model="form.JYUMINHYO_YUBIN2"
                  :state="errors.length ? false : null"
                  placeholder="0023"
                  trim
                />
                <b-form-invalid-feedback>
                  <span class="border-red">{{ errors[0] }}</span>
                </b-form-invalid-feedback>
              </validation-provider>
            </div>
            <button
              type="button"
              class="btn btn-success bold"
              @click="searchAddress"
              :disabled="!isYubinSearch"
              style="height: 40px"
            >
              検索
            </button>
          </div>
        </td>
      </tr>
      <tr v-if="isDiffrent">
        <th>
          住民票 都道府県・市区郡
          <span class="must">必須</span>
        </th>
        <td>
          <div class="row">
            <div class="col-4 col-md-4 col-lg-3 pr-0">
              <validation-provider
                v-slot="{ errors }"
                name="JYUMINHYO_TODO_CD"
                rules="required"
                ref="JYUMINHYO_TODO_MEI"
              >
                <b-form-select
                  v-model="form.JYUMINHYO_TODO_CD"
                  ref="JYUMINHYO_TODO_CD"
                  :state="errors.length ? false : null"
                  :options="prefList"
                  trim
                  @change="changePref"
                />
                <b-form-invalid-feedback>
                  <span class="border-red">{{ errors[0] }}</span>
                </b-form-invalid-feedback>
              </validation-provider>
            </div>
            <div class="col-7 col-md-5 col-lg-4">
              <validation-provider
                v-slot="{ errors }"
                name="JYUMINHYO_SHIKU_CD"
                rules="required"
                ref="JYUMINHYO_SHIKU_MEI"
              >
                <b-form-select
                  :disabled="!cityList.length"
                  ref="JYUMINHYO_SHIKU_CD"
                  v-model="form.JYUMINHYO_SHIKU_CD"
                  :state="errors.length ? false : null"
                  :options="cityList"
                  trim
                  @change="changeCity"
                />
                <b-form-invalid-feedback>
                  <span class="border-red">{{ errors[0] }}</span>
                </b-form-invalid-feedback>
              </validation-provider>
            </div>
          </div>
        </td>
      </tr>
      <tr v-if="isDiffrent">
        <th>
          住民票 町名・番地
          <span class="must">必須</span>
        </th>
        <td>
          <validation-provider
            name="JYUMINHYO_BANCHI"
            v-slot="{ errors }"
            rules="required|max:25|char"
          >
            <b-form-input
              maxlength="25"
              ref="JYUMINHYO_BANCHI"
              v-model="form.JYUMINHYO_BANCHI"
              :state="errors.length ? false : null"
              placeholder="西新宿7－4－3 升本ビル4F"
              trim
              @blur="form.JYUMINHYO_BANCHI = replaceChar(form.JYUMINHYO_BANCHI)"
            />
            <b-form-invalid-feedback>
              <span class="border-red">{{ errors[0] }}</span>
            </b-form-invalid-feedback>
          </validation-provider>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import Mixin from '@/components/mixin/Mixin'
import Constant from '@/const'
import Store from '@/store/index.js'
import _ from 'lodash'

export default {
  name: 'Resident',

  mixins: [Mixin],

  props: {
    /** データ取得フラグ */
    isGetData: {
      type: Boolean,
      default: false,
    },

    /** データ設定フラグ */
    isSetData: {
      type: Boolean,
      default: false,
    },

    /** オブザーバー */
    observer: {
      type: Object,
      default: null,
    },

    /** 親入力データ */
    parent: {
      type: Object,
      default: null,
    },
  },

  data: () => ({
    /** 市区町村リスト */
    cityList: [],

    /** 入力データ */
    form: {
      JYUMINHYO_FLG: 0,
      JYUMINHYO_DAIKO_FLG: 0,
      JYUMINHYO_DAIKO_YEAR: null,
      JYUMINHYO_DAIKO_MONTH: null,
      JYUMINHYO_DAIKO_DAY: null,
      JYUMINHYO_YUBIN1: null,
      JYUMINHYO_YUBIN2: null,
      JYUMINHYO_TODO_CD: null,
      JYUMINHYO_TODO_MEI: null,
      JYUMINHYO_SHIKU_CD: '',
      JYUMINHYO_SHIKU_MEI: null,
      JYUMINHYO_BANCHI: null,
    },
  }),

  methods: {
    /** 入力データを精設定する */
    setData() {
      if (this.parent) {
        for (var name in this.form) {
          if (this.parent[name] !== undefined)
            this.form[name] = this.parent[name]
        }
        this.getCityList()
      }
    },

    /** 都道府県変更 */
    changePref() {
      const todoCd = this.form.JYUMINHYO_TODO_CD
      this.form.JYUMINHYO_TODO_MEI = null
      this.form.JYUMINHYO_SHIKU_CD = ''
      this.form.JYUMINHYO_SHIKU_MEI = null
      if (todoCd) {
        this.form.JYUMINHYO_TODO_MEI = this.getText(this.prefList, todoCd)
        this.getCityList()
      } else this.cityList = []
    },

    /** 市区町村変更 */
    changeCity() {
      const shikuCd = this.form.JYUMINHYO_SHIKU_CD
      this.form.JYUMINHYO_SHIKU_MEI = null
      if (shikuCd) {
        this.form.JYUMINHYO_SHIKU_MEI = this.getText(this.cityList, shikuCd)
      }
    },

    /** 市区町村リスト取得 */
    getCityList() {
      if (!this.form.JYUMINHYO_TODO_CD) return
      return Store.dispatch(
        'address/getCityList',
        this.form.JYUMINHYO_TODO_CD
      ).then(() => {
        const cityList = _.cloneDeep(Store.state.address.cityList)
        cityList.unshift({
          value: '',
          text: '未選択',
        })
        this.cityList = cityList
      })
    },

    /** 郵便番号検索 */
    searchAddress() {
      this.getAreaFromZipCd(
        `${this.form.JYUMINHYO_YUBIN1}${this.form.JYUMINHYO_YUBIN2}`
      ).then(async (item) => {
        if (item) {
          this.form.JYUMINHYO_TODO_CD = ('00' + item.prefcode).slice(-2)
          this.form.JYUMINHYO_TODO_MEI = this.getText(
            this.prefList,
            this.form.JYUMINHYO_TODO_CD
          )
          this.form.JYUMINHYO_SHIKU_MEI = item.address2
          this.form.JYUMINHYO_BANCHI = item.address3
          await this.getCityList()
          const city = this.getParam(
            this.cityList,
            this.form.JYUMINHYO_SHIKU_MEI,
            'text'
          )
          if (city) this.form.JYUMINHYO_SHIKU_CD = city.value
        }
      })
    },

    /** 表示された入力データのみ設定する */
    cleanup() {
      let d = _.cloneDeep(this.form)
      for (var name in d) {
        if (!this.$refs[name]) delete d[name]
      }
      if (
        d.JYUMINHYO_DAIKO_FLG &&
        (!d.JYUMINHYO_DAIKO_YEAR ||
          !d.JYUMINHYO_DAIKO_MONTH ||
          !d.JYUMINHYO_DAIKO_DAY)
      ) {
        d.JYUMINHYO_DAIKO_YEAR = null
        d.JYUMINHYO_DAIKO_MONTH = null
        d.JYUMINHYO_DAIKO_DAY = null
      }
      return d
    },
  },

  computed: {
    /** 郵便検索可能か */
    isYubinSearch() {
      return (
        this.form.JYUMINHYO_YUBIN1 &&
        this.form.JYUMINHYO_YUBIN2 &&
        this.observer &&
        this.observer.fields.JYUMINHYO_YUBIN1 &&
        this.observer.fields.JYUMINHYO_YUBIN2 &&
        !this.observer.fields.JYUMINHYO_YUBIN1.failed &&
        !this.observer.fields.JYUMINHYO_YUBIN2.failed
      )
    },

    /** 住民票と登録地が異なるか */
    isDiffrent() {
      return Number(this.form.JYUMINHYO_FLG) === 1
    },
  },

  watch: {
    /* データ取得フラグ監視 */
    async isGetData(val) {
      if (val) this.$emit('setData', this.cleanup())
    },

    /* データ設定フラグ監視 */
    async isSetData(val) {
      if (val) this.setData()
    },
  },
}
</script>

<style lang="sass" scoped>
@import '../../../assets/css/logico2'
table
  margin: 0
  th
    background: $baseBlueColor
    color: #fff
    width: 32%
    padding: 1.5%
  td
    width: 68%
    background: #fff
</style>



// WEBPACK FOOTER //
// src/components/order/meihen/Resident.vue